export const REQ_TIRESMIN_SUCCESS = "REQ_TIRESMIN_SUCCESS"